// extracted by mini-css-extract-plugin
export default {"main_container":"EventDetails_main_container__uUWL2","scrollable":"EventDetails_scrollable__5Ai1Y"};